'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Star } from '../Star/Star.js';
export const StarRating = (_a) => {
    var { behavior, className, label = false, value = 0, max = 5, size, editable, ratingAfter, labelBefore } = _a, other = __rest(_a, ["behavior", "className", "label", "value", "max", "size", "editable", "ratingAfter", "labelBefore"]);
    const [starsValue, setStarValue] = React.useState(0);
    const updateStar = (idx) => {
        setStarValue(idx + 1);
    };
    const componentClassName = classnames('sparky-c-star-rating', className, {
        'sparky-c-star-rating--wrap': behavior === 'wrap',
        'sparky-c-star-rating--lg': size === 'lg',
        'sparky-c-star-rating--md': size === 'md',
        'sparky-c-star-rating--sm': size === 'sm',
    });
    const isPartial = value % 1 !== 0;
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [label && labelBefore ? (_jsx("div", Object.assign({ className: "sparky-c-star-rating__label-group sparky-c-star-rating__label-before" }, { children: value }))) : null, _jsx("div", Object.assign({ className: "sparky-c-star-rating__icons", "aria-label": `${value || starsValue} out of ${max} stars selected` }, { children: Array.from(Array(max).keys()).map((_, idx) => {
                    let variant;
                    if (Math.floor(value || starsValue) === idx && isPartial) {
                        variant = 'half';
                    }
                    else if (idx < (value || starsValue)) {
                        variant = 'full';
                    }
                    else {
                        variant = undefined;
                    }
                    return editable ? (_jsx("button", Object.assign({ onClick: () => updateStar(idx), type: "button", className: "sparky-c-star-rating__button", "aria-label": `Select ${idx + 1} out of ${max} stars`, "aria-pressed": starsValue === idx + 1 && true }, { children: _jsx(Star, { variant: variant, size: size }) }), `star-${idx}`)) : (_jsx(Star, { variant: variant, size: size }, `star-${idx}`));
                }) })), label && !labelBefore ? (_jsx("div", Object.assign({ className: "sparky-c-star-rating__label-group" }, { children: `(${value})` }))) : null, ratingAfter && (_jsx("div", Object.assign({ className: "sparky-c-star-rating__rating-after", "aria-label": `${ratingAfter} reviews` }, { children: ratingAfter })))] })));
};
//# sourceMappingURL=StarRating.js.map